import { useClientTranslation } from '@lib/i18n/client';
import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
import { Button } from '@tuic/web-compositions/core/Button';
import { Pictogram } from '@tuic/web-compositions/core/Pictogram';
import { useCallback } from 'react';

import type { RefreshDialogHandler } from '@modules/get-slash-internet-card/components/dialog-view-renderer';
import type { PictogramName } from '@tuic/web-compositions/core/Pictogram';
import type { FC } from 'react';

type Props = {
  pictogram?: PictogramName;
  headline?: string;
  text?: string;
  furtherButtonLabel?: string;
  refreshDialog: RefreshDialogHandler;
};

export const BookingSuccess: FC<Props> = props => {
  const { pictogram, headline, text, furtherButtonLabel, refreshDialog } =
    props;
  const { t } = useClientTranslation();

  const handleClick = useCallback(() => {
    refreshDialog({
      indicator: true,
    });
  }, [refreshDialog]);

  return (
    <DialogBody colored>
      <div className="text-center text-marine-high-emphasis">
        <div className="space-y-6">
          <div className="space-y-4">
            <Pictogram name={pictogram ?? 'checkmark'} size="md" />
            <h3 className="headline-lg">
              {headline ?? t('Buchung bestätigt')}
            </h3>
          </div>
          <p>
            {text ??
              t(
                'Ihr Internettarif ist gebucht – Sie können ihn sofort aktivieren!',
              )}
          </p>
        </div>

        <Button onClick={handleClick} className="mt-4">
          {furtherButtonLabel ?? t('Tarif jetzt starten')}
        </Button>
      </div>
    </DialogBody>
  );
};
